// extracted by css-extract-rspack-plugin
export default {"skeleton":"TableSkeletonRow_skeleton__IVWYq"};